@if (!['salesforce', 'service_now'].includes(platform)) {
  <div class="environments" *ngIf="!['salesforce', 'service_now'].includes(platform)">
    <div *ngIf="isLoading()" class="environments-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>

    <div class="environments-header" *ngIf="isLoading() === false">
      <div class="environments-header-text">
        {{ 'policyPage.policy.environments.title' | labelsProvider }}
      </div>
    </div>
    <div class="environments-body" *ngIf="isLoading() === false">
      <div class="environments-body-search">
        <app-autocomplete-search
          class="environments-body-search-box"
          placeholder="Search..."
          (autocompleteOnChange)="environmentSearched($event)"
          [values]="environmentsDisplayNamesForSearch"
          [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
        ></app-autocomplete-search>
      </div>

      <div class="environments-body-table">
        <app-table
          [tableColumns]="environmentsTableCols"
          [tableRows]="tableRows"
          [isLoading]="isLoading()"
          [isScrollable]="true"
          [withPagination]="true"
          [withCheckbox]="true"
          [pageInfo]="pageInfo$.value"
          [noData]="noData()"
          (checkboxOnClick)="onCheckboxClick($event)"
          (pageOnChange)="onPagination($event)"
        >
        </app-table>
      </div>
    </div>

    @if (editable && isLoading() === false) {
      <app-form-footer
        [changesWereDone]="changesWereDone"
        (resetChanges)="resetForm()"
        (saveChanges)="setEnvironments()"
        (cancelSettings)="cancelEdit()"
      >
      </app-form-footer>
    }
  </div>
} @else {
  <app-coming-soon class="environments-spinner"> </app-coming-soon>
}
